import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { useTheme } from 'styled-components';
import { Auth } from 'aws-amplify';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Collapse from 'react-bootstrap/Collapse';
import Fade from 'react-bootstrap/Fade';

import Button from '../../../components/Button';
import FormInput from '../../../components/FormInput';

const ChangePassword = () => {
  const [infoSaved, setInfoSaved] = useState(false);
  const [infoSavedFade, setInfoSavedFade] = useState(false);
  const [loading, setLoading] = useState(false);

  const timeoutRef = useRef();
  const theme = useTheme();

  const changePassword = ({ oldPassword, newPassword }) => {
    setLoading(true);
    Auth.currentAuthenticatedUser()
      .then((user) => {
        return Auth.changePassword(user, oldPassword, newPassword);
      })
      .then(() => {
        setInfoSaved(true);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setLoading(false);
      });
  };

  const validationSchema = yup.object().shape({
    oldPassword: yup.string().required('Obligatoriskt fält'),
    newPassword: yup
      .string()
      .min(8, 'Ditt lösenord måste ha minst 8 tecken')
      .required('Obligatoriskt fält'),
    newPasswordRepeat: yup
      .string()
      .required('Obligatoriskt fält')
      .oneOf([yup.ref('newPassword')], 'Lösenorden matchar inte'),
  });

  return (
    <Col>
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          oldPassword: '',
          newPassword: '',
          newPasswordRepeat: '',
        }}
        onSubmit={changePassword}
      >
        {({ values, errors, submitCount, handleChange }) => {
          const showErrors = submitCount > 0;

          return (
            <Form>
              <Col>
                <Row>
                  <Col>
                    <FormInput
                      onChange={handleChange('oldPassword')}
                      value={values.oldPassword}
                      label="Nuvarande lösenord"
                      error={showErrors && errors.oldPassword}
                      type="password"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormInput
                      onChange={handleChange('newPassword')}
                      value={values.newPassword}
                      label="Nytt lösenord"
                      error={showErrors && errors.newPassword}
                      type="password"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormInput
                      onChange={handleChange('newPasswordRepeat')}
                      value={values.newPasswordRepeat}
                      label="Upprepa nytt lösenord"
                      error={showErrors && errors.newPasswordRepeat}
                      type="password"
                    />
                  </Col>
                </Row>
              </Col>

              <Collapse
                in={infoSaved}
                onEntered={() => {
                  setInfoSavedFade(true);
                }}
              >
                <Fade
                  timeout={500}
                  in={infoSavedFade}
                  onEntered={() => {
                    timeoutRef.current = setTimeout(() => {
                      setInfoSaved(false);
                      setInfoSavedFade(false);
                    }, 5000);
                  }}
                >
                  <Row className="flex-row-reverse">
                    <Col xs="auto">
                      <p
                        style={{
                          color: theme.colors.darkGrayColor,
                        }}
                      >
                        <FormattedMessage defaultMessage="Ditt lösenord har ändrats" />
                      </p>
                    </Col>
                  </Row>
                </Fade>
              </Collapse>

              <Row className="flex-row-reverse mt-2">
                <Col xs="auto">
                  <Button isLoading={loading} type="submit">
                    <FormattedMessage defaultMessage="Spara" />
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </Col>
  );
};

export default ChangePassword;
